<template>
    <div :key="$route.fullPath" class="signings signings-tab" data-test="signing">
        <b-card no-body>
            <b-tabs card>
                <b-tab
                    v-if="isUserAdmin"
                    :active="activeComponent === 'ReviewDocuments'"
                    @click="getReviewDocuments"
                >
                    <template #title>
                        <div class="d-flex flex-column py-1">
                            <!-- <div class="total-document text-dark h1">
                                {{ documentCount.reviewDocumentCount }}
                            </div> -->
                            <div style="display:inline-block">
                                <!-- <span class="status-circle pending"></span> -->
                                Review Documents
                                <span class="status-count pending"
                                    :data-test="`review-document-${documentCount.reviewDocumentsCount}`"
                                >
                                    {{ documentCount.reviewDocumentsCount }}
                                </span>
                            </div>
                        </div>
                    </template>

                    <b-card-text v-if="activeComponent === 'ReviewDocuments'">
                        <review-documents
                            :is-loading="isLoading"
                            :is-uploading-external-document-props="isUploadingExternalDocument"
                            :document-title="documentTitle"
                            :is-downloading-zip="isDownloadingZip"
                            :is-sending-mail="isSendingMail"
                            :review-documents-data="reviewDocumentsData"
                            :active-document-id="activeDocumentId"
                            :should-open-pdf-viewer-modal="shouldOpenPdfViewerModal"
                            :remove-current-id-from-selected-ids="removeCurrentIdFromSelectedIds"
                            @view="view"
                            @remove="remove"
                            @revert="revert"
                            @close="shouldOpenPdfViewerModal = false"
                            @download="download"
                            @sendEmail="sendEmail"
                            @filterBy="filterBy"
                            @uploadExternalDocument="uploadExternalDocument"
                            @physicallySigned="physicallySigned"
                            @dropboxSigned="dropboxSigned"
                            @markAsSigned="markAsSigned"
                        />

                        <b-sidebar
                            id="sidebar-task-handler"
                            class="sidebar"
                            sidebar-class="sidebar-lg"
                            :visible="isRevertSidebarActive"
                            bg-variant="white"
                            shadow
                            backdrop
                            no-header
                            right
                            @hidden="isRevertSidebarActive = false"
                        >
                            <template #default="{ hide }">
                                <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1 side-bar-header" style="background-color: #f6f6f6">
                                    <h3 class="mb-0">
                                        Reset Signing Status
                                    </h3>

                                    <div>
                                        <feather-icon
                                            class="ml-1 cursor-pointer"
                                            icon="XIcon"
                                            size="16"
                                            @click="hide"
                                        />
                                    </div>
                                </div>

                                <div class="px-2 py-2" style="font-size: 12.72px; font-weight: 400; line-height: 18.44px; color: rgb(75, 75, 75)">
                                    <p style="padding-top: 2px; font-size: 12.72px; font-weight: 400; line-height: 18.44px; color: rgb(75, 75, 75);">To reset the signing status, just follow these simple instructions below.</p>

                                    <ol style="padding-left: 2em; line-height: 2.5em">
                                        <li>
                                            Click
                                            <a href="#" style="text-decoration: underline" @click="revertNow">
                                                Open Document In Google Docs
                                            </a>.

                                            <span id="revert-warning" style="padding-left: 1px"><feather-icon icon="AlertCircleIcon" size="16" /></span>
                                            <b-tooltip target="revert-warning" triggers="hover">
                                                When <strong>Open Document In Google Docs</strong> is clicked all signatures will be reset in <b>Enston Secretary</b> even though the google docs document has not yet reset the signing status.
                                            </b-tooltip>
                                        </li>
                                        <li>Go to <strong>"File > Version History > See Version History"</strong>.</li>
                                        <li>Select the version to reset the signing status. Just a heads-up, usually the version status is <strong>the second one listed from the bottom</strong>.</li>
                                        <li>Click <span size="sm" style="background-color: #0b57d0;padding: 5px 13px; font-size: .9em; border-radius: 100px; color: white;">Restore this version</span> button.</li>
                                    </ol>

                                    <div class="d-flex justify-content-end">
                                        <b-button
                                            class="
                                            mt-1 
                                            d-flex
                                            justify-content-center
                                            align-items-center"
                                            variant="outline-primary"
                                            data-test="cancel"
                                            @click="isRevertSidebarActive = false"
                                        >
                                            Cancel
                                            <vector 
                                                data-type="icons" 
                                                data-width="15px" 
                                                data-height="15px" 
                                                data-name="cancel" 
                                                class="float-right ml-1"
                                                alt="cancel-logo"
                                            />
                                        </b-button>
                                    </div>
                                </div>
                            </template>
                        </b-sidebar>

                        <!-- delete -->
                        <confirmation-modal  ref="modal">
                            <template slot="body">
                                <div>
                                    <feather-icon class="d-block mx-auto text-warning" icon="AlertCircleIcon" size="90"/>
                                    <h1 class="text-center text-secondary display-5 mt-2">Are you sure?</h1>
                                    <p class="text-center mt-2"> You won't be able to revert this! </p>
                                </div>
                            </template>

                            <template slot="footer">
                                <b-button class="d-flex" :disabled="isDeleting" size="md" variant="primary" @click="confirmDelete">
                                    Yes, delete it!
                                    <normal-loader v-if="isDeleting" class="left-10%" />
                                </b-button>

                                <b-button size="md" variant="outline-danger" @click="cancelDelete">
                                    Cancel
                                </b-button>
                            </template>
                        </confirmation-modal>
                    </b-card-text>
                </b-tab>

                <b-tab
                    v-if="isUserAdmin"
                    :active="activeComponent === 'PendingSignaturesDocument'"
                    @click="getPendingSignaturesDocumentData"
                >
                    <template #title>
                        <div class="d-flex flex-column py-1">
                            <div style="display:inline-block">
                                Awaiting signature
                                <span class="status-count pending"
                                    :data-test="`awaiting-signature-${documentCount.pendingDocumentsCount}`"
                                >
                                    {{ documentCount.pendingDocumentsCount }}
                                </span>
                            </div>
                        </div>
                    </template>

                    <b-card-text v-if="activeComponent === 'PendingSignaturesDocument'">
                        <pending-signatures-document
                            :is-loading="isLoading"
                            :document-title="documentTitle"
                            :pending-signatures-document-data="pendingSignaturesDocumentData"
                            :active-document-id="activeDocumentId"
                            :should-open-pdf-viewer-modal="shouldOpenPdfViewerModal"
                            :is-signing-all="isSigningAll"
                            @view="view"
                            @sign="sign"
                            @signAll="signAll"
                            @close="shouldOpenPdfViewerModal = false"
                            @filterBy="filterBy"
                        />
                    </b-card-text>
                </b-tab>

                <b-tab
                    :active="activeComponent === 'PendingYourSignaturesDocument'"
                    @click="getPendingYourSignaturesDocumentData"
                >
                    <template #title>
                        <div class="d-flex flex-column py-1">
                            <div style="display:inline-block">
                                Awaiting your signature
                                <span
                                    class="status-count pending"
                                    :data-test="`awaiting-your-signature-${documentCount.pendingYourDocumentCount}`"
                                >
                                    {{ documentCount.pendingYourDocumentCount }}
                                </span>
                            </div>
                        </div>
                    </template>

                    <b-card-text v-if="activeComponent === 'PendingYourSignaturesDocument'">
                        <pending-your-signatures-document
                            ref="pendingYourSignatures"
                            :is-loading="isLoading"
                            :document-title="documentTitle"
                            :pending-your-signatures-document-data="pendingYourSignaturesDocumentData"
                            :active-document-id="activeDocumentId"
                            :should-open-pdf-viewer-modal="shouldOpenPdfViewerModal"
                            :is-signing-all="isSigningAll"
                            @view="view"
                            @sign="sign"
                            @signAll="signAll"
                            @close="shouldOpenPdfViewerModal = false"
                            @filterBy="filterBy"
                        />
                    </b-card-text>
                </b-tab>

                <b-tab  @click="getPendingOtherSignaturesDocumentData">
                    <template #title>
                        <div class="d-flex flex-column py-1">
                            <div style="display:inline-block">
                                Awaiting others' signature
                                <span
                                    class="status-count pending"
                                    :data-test="`awaiting-other-signature-${documentCount.pendingOtherDocumentsCount}`"
                                >
                                    {{ documentCount.pendingOtherDocumentsCount }}
                                </span>
                            </div>
                        </div>
                    </template>

                    <b-card-text v-if="activeComponent === 'PendingOtherSignaturesDocument'">
                        <pending-other-signatures-document
                            :is-loading="isLoading"
                            :document-title="documentTitle"
                            :pending-other-signatures-document-data="pendingOtherSignaturesDocumentData"
                            :active-document-id="activeDocumentId"
                            :should-open-pdf-viewer-modal="shouldOpenPdfViewerModal"
                            @view="view"
                            @close="shouldOpenPdfViewerModal = false"
                            @filterBy="filterBy"
                        />
                    </b-card-text>
                </b-tab>

                <b-tab @click="getSignedSignaturesDocumentData">
                    <template #title>
                        <div class="d-flex flex-column py-1">
                            <div style="display:inline-block">
                                <!-- <span class="status-circle completed"></span> -->
                                Completed
                                <span
                                    class="status-count completed"
                                    :data-test="`completed-signature-${documentCount.signedDocumentsCount}`"
                                 >
                                    {{ documentCount.signedDocumentsCount }}
                                </span>
                            </div>
                        </div>
                    </template>

                    <b-card-text v-if="activeComponent === 'SignedSignaturesDocument'">
                        <signed-signatures-document
                            :is-loading="isLoading"
                            :document-title="documentTitle"
                            :signed-signatures-document-data="signedSignaturesDocumentData"
                            :active-document-id="activeDocumentId"
                            :should-open-pdf-viewer-modal="shouldOpenPdfViewerModal"
                            @view="view"
                            @close="shouldOpenPdfViewerModal = false"
                            @filterBy="filterBy"
                        />
                    </b-card-text>
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>

<script>
import { BCard, BTabs, BTab, BCardText, BButton, BSidebar, BTooltip } from "bootstrap-vue";
import { mapGetters } from "vuex";
import { DOCUMENT, PROCESS } from '@/constants/config';
import { updateCurrentCompanyInStore, formatDate } from '@/helpers';
import SigningList from '@/models/SigningList';
import Document from '@/models/Document';
// import GenerateDocument from '@/models/GenerateDocument';
import { localize } from '@/localize/fileDataLocalizer';
import {
    ERROR_WHILE_TRYING_TO_SIGN_ALREADY_SIGNED_DOCUMENT,
    ERROR_WHILE_TRYING_TO_SIGN_SUBMITTED_TO_SIGN_DOCUMENT,
    ERROR_WHILE_TRYING_TO_VIEW_SIGNING_PROCESS_DOCUMENT,
    SOMETHING_WENT_WRONG
} from '@/constants/errors';
import { DOWNLOAD_REQUEST_SUCCESS } from "@/constants/success";
import { errorToast, successToast } from '@/views/helpers/toast';
import SignedSignaturesDocument from './SignedSignaturesDocument.vue';
import PendingOtherSignaturesDocument from './PendingOtherSignaturesDocument.vue';
import PendingYourSignaturesDocument from './PendingYourSignaturesDocument.vue';
import PendingSignaturesDocument from './PendingSignaturesDocument.vue';
import ReviewDocuments from './ReviewDocuments.vue';
import ConfirmationModal from '@/views/components/utils/ConfirmationModal.vue';


export default {
    components: {
        BCard,
        BTabs,
        BTab,
        BCardText,
        BButton,

        ReviewDocuments,
        PendingSignaturesDocument,
        PendingYourSignaturesDocument,
        PendingOtherSignaturesDocument,
        SignedSignaturesDocument,
        ConfirmationModal,
        BSidebar,
        BTooltip
    },

    data() {
        return {
            activeComponent: 'PendingYourSignaturesDocument',
            documentTitle: null,

            isLoading: false,
            process: '',
            isDownloadingZip: false,
            isSendingMail: false,
            documentCount: {
                reviewDocumentsCount: '--',
                pendingDocumentsCount: '--',
                pendingOtherDocumentsCount: '--',
                pendingYourDocumentCount: '--',
                signedDocumentsCount: '--',
            },
            reviewDocumentsData: [],
            pendingSignaturesDocumentData: [],
            pendingYourSignaturesDocumentData: [],
            pendingOtherSignaturesDocumentData: [],
            signedSignaturesDocumentData: [],
            signInProcessDocuments: [],
            sendingInProcessDocIds:[],
            signInProcessingIntervalIds: [],
            sendMailProcessingIntervalIds: [],
            removeCurrentIdFromSelectedIds: [],
            signAllDocumentIds: [],
            signSingleDocumentIds: [],

            activeDocumentId: 0,
            shouldOpenPdfViewerModal: false,
            showToastCount: 0,
            showEmailSentSuccessToast: false,
            isSignProcessing: false,
            isSingInProcessingDocsLive: false,

            // to show waiting if sign all is clicked
            isSigningAll: 'no',
            isUploadingExternalDocument: false,
            isDeleting: false,
            dataToDelete: null,
            dataToRevert: null,
            isRevertSidebarActive: false
        };
    },

    computed: {
        ...mapGetters({
            'isUserAdmin': 'auth/isAdmin',
            'signatureInvitationMailSent': 'document/signatureInvitationMailSent',
            filterData: 'filterDocuments/getFilterBy',
        }),
    },

    watch:
    {
        $route() {
            this.setUpData();
        },
    },

    async created()
    {
        this.setUpData();
        window.localStorage.signatureInvitationMailSent = false;
        window.localStorage.signDocumentProcessing = false;

        this.isSigningAll = window.localStorage.isSigningAll;

        window.addEventListener('storage', async () => {
            if (window.localStorage.isSigningAll === 'yes')
            {
                this.isSigningAll = 'yes';
            }

            if(this.showEmailSentSuccessToast) {
                // local storage return string value even for boolean set data
                if (window.localStorage.signatureInvitationMailSent === "true")
                {
                    this.showEmailSentSuccessToast = false;
                    window.localStorage.signatureInvitationMailSent = false;

                    this.setSendEmailDataLive();
                }
            }

            if(this.isSignProcessing) {
                // local storage return string value even for boolean set data
                if(window.localStorage.signDocumentProcessing === "true") {
                    this.isSignProcessing = false;
                    window.localStorage.signDocumentProcessing = false;

                    // merge all signing process documents ids in one array
                    const liveRequestList = this.signSingleDocumentIds.concat(this.signAllDocumentIds);
                    this.signInProcessDocuments = [...new Set([...this.signInProcessDocuments, ...liveRequestList])];
                    this.setSignDocumentDataLive(this.signInProcessDocuments);
                }
            }
        });
    },

    beforeDestroy () {
        this.signInProcessingIntervalIds.forEach(id => {
            clearInterval(id);
        });
        this.sendMailProcessingIntervalIds.forEach(id => {
            clearInterval(id);
        });
    },

    methods: {
        async setUpData()
        {
            this.$store.dispatch('filterDocuments/CLEAR_FILTER');
            this.clearLocalData();

            if (this.$route.name === 'pre-incorporation') {
                this.process = PROCESS.PRE_INCORPORATION;
                this.documentTitle = "Pre-incorporation Documents";
                this.fetchStartUpData();
                await updateCurrentCompanyInStore().catch(() => {});
            } else if (this.$route.name === 'incorporation') {
                this.process = PROCESS.INCORPORATION;
                this.documentTitle = "Incorporation Documents";
                this.fetchStartUpData();
                await updateCurrentCompanyInStore().catch(() => {});
            } else if (this.$route.name === 'secretary-appointment') {
                this.process = PROCESS.SECRETARY_APPOINTMENT;
                this.documentTitle = "Secretary Appointment Documents";
                this.fetchStartUpData();
                await updateCurrentCompanyInStore().catch(() => {});
            } else if (this.$route.name === 'change-of-fye') {
                this.process = PROCESS.CHANGE_OF_FYE;
                this.documentTitle = "Change FYE Documents";
                this.isLoading = true;

                this.setupFilterByYearOptions()
                    .then(async() => {
                        this.fetchStartUpData();
                        await updateCurrentCompanyInStore().catch(() => {});
                    })
                    // eslint-disable-next-line no-console
                    .catch(e => console.log("Error while fetching filter by year options", e));
            } else if (this.$route.name === 'director-fee') {
                this.process = PROCESS.DIRECTOR_FEE;
                this.documentTitle = "Director's Fee Documents";
                this.isLoading = true;

                this.setupFilterByYearOptions()
                    .then(async() => {
                        this.fetchStartUpData();
                        await updateCurrentCompanyInStore().catch(() => {});
                    })
                    // eslint-disable-next-line no-console
                    .catch(e => console.log("Error while fetching filter by year options", e));
            } else if (this.$route.name === 'director-changes') {
                this.process = PROCESS.CHANGE_DIRECTOR;
                this.documentTitle = "Director Changes Documents";
                this.isLoading = true;

                this.setupFilterByYearOptions()
                    .then(async() => {
                        this.fetchStartUpData();
                        await updateCurrentCompanyInStore().catch(() => {});
                    })
                    // eslint-disable-next-line no-console
                    .catch(e => console.log("Error while fetching filter by year options", e));
            } else if (this.$route.name === 'nominator-changes-documents') {
                this.process = PROCESS.CHANGE_NOMINATOR;
                this.documentTitle = "Nominator Changes Documents";
                this.isLoading = true;

                this.setupFilterByYearOptions()
                    .then(async() => {
                        this.fetchStartUpData();
                        await updateCurrentCompanyInStore().catch(() => {});
                    })
                    // eslint-disable-next-line no-console
                    .catch(e => console.log("Error while fetching filter by year options", e));
            } else if (this.$route.name === 'update-of-particulars-documents') {
                this.process = PROCESS.UPDATE_OF_PARTICULARS;
                this.documentTitle = "Update of Particulars Documents";
                this.isLoading = true;

                this.setupFilterByYearOptions()
                    .then(async() => {
                        this.fetchStartUpData();
                        await updateCurrentCompanyInStore().catch(() => {});
                    })
                    // eslint-disable-next-line no-console
                    .catch(e => console.log("Error while fetching filter by year options", e));
            } else if (this.$route.name === 'auditor-changes') {
                this.process = PROCESS.CHANGE_AUDITOR;
                this.documentTitle = "Auditor Changes Documents";
                this.isLoading = true;

                this.setupFilterByYearOptions()
                    .then(async() => {
                        this.fetchStartUpData();
                        await updateCurrentCompanyInStore().catch(() => {});
                    })
                    // eslint-disable-next-line no-console
                    .catch(e => console.log("Error while fetching filter by year options", e));
            } else if (this.$route.name === 'secretaries-resignation-documents') {
                this.process = PROCESS.SECRETARY_RESIGNATION;
                this.documentTitle = "Secretary Resignation Documents";
                this.isLoading = true;

                this.setupFilterByYearOptions()
                    .then(async() => {
                        this.fetchStartUpData();
                        await updateCurrentCompanyInStore().catch(() => {});
                    })
                    // eslint-disable-next-line no-console
                    .catch(e => console.log("Error while fetching filter by year options", e));
            } else if (this.$route.name === 'data-protection-officers-documents') {
                this.process = PROCESS.DATA_PROTECTION_OFFICER;
                this.documentTitle = "Data Protection Officer Documents";
                this.isLoading = true;

                this.setupFilterByYearOptions()
                    .then(async() => {
                        this.fetchStartUpData();
                        await updateCurrentCompanyInStore().catch(() => {});
                    })
                    // eslint-disable-next-line no-console
                    .catch(e => console.log("Error while fetching filter by year options", e));
            } else if (this.$route.name === 'change-ro') {
                this.process = PROCESS.CHANGE_RO;
                this.documentTitle = "Change Registered Office Document";
                this.isLoading = true;

                this.setupFilterByYearOptions()
                    .then(async() => {
                        this.fetchStartUpData();
                        await updateCurrentCompanyInStore().catch(() => {});
                    })
                    // eslint-disable-next-line no-console
                    .catch(e => console.log("Error while fetching filter by year options", e));
            } else if (this.$route.name === 'change-of-company-name-documents') {
                this.process = PROCESS.CHANGE_OF_COMPANY_NAME;
                this.documentTitle = "Change of Company Name Document";
                this.isLoading = true;

                this.setupFilterByYearOptions()
                    .then(async() => {
                        this.fetchStartUpData();
                        await updateCurrentCompanyInStore().catch(() => {});
                    })
                    // eslint-disable-next-line no-console
                    .catch(e => console.log("Error while fetching filter by year options", e));
            } else if (this.$route.name === 'annual-return') {
                this.process = PROCESS.ANNUAL_RETURN;
                this.documentTitle = "Annual Return Documents";
                this.isLoading = true;

                this.setupFilterByYearOptions()
                    .then(async() => {
                        this.fetchStartUpData();
                        await updateCurrentCompanyInStore().catch(() => {});
                    })
                    // eslint-disable-next-line no-console
                    .catch(e => console.log("Error while fetching filter by year options", e));
            } else if (this.$route.name === 'interim-dividend') {
                this.process = PROCESS.INTERIM_DIVIDEND;
                this.documentTitle = "Interim Dividend Document";
                this.isLoading = true;

                this.setupFilterByYearOptions()
                    .then(async() => {
                        this.fetchStartUpData();
                        await updateCurrentCompanyInStore().catch(() => {});
                    })
                    // eslint-disable-next-line no-console
                    .catch(e => console.log("Error while fetching filter by year options", e));
            } else if (this.$route.name === 'agm') {
                this.process = PROCESS.AGM;
                this.documentTitle = "AGM Documents";
                this.isLoading = true;

                this.setupFilterByYearOptions()
                    .then(async() => {
                        this.fetchStartUpData();
                        await updateCurrentCompanyInStore().catch(() => {});
                    })
                    // eslint-disable-next-line no-console
                    .catch(e => console.log("Error while fetching filter by year options", e));
            } else if (this.$route.name === 'agm-dispensation-documents') {
                this.process = PROCESS.AGM_DISPENSATION;
                this.documentTitle = "AGM Dispensation Documents";
                this.isLoading = true;

                this.setupFilterByYearOptions()
                    .then(async() => {
                        this.fetchStartUpData();
                        await updateCurrentCompanyInStore().catch(() => {});
                    })
                    // eslint-disable-next-line no-console
                    .catch(e => console.log("Error while fetching filter by year options", e));
            } else if (this.$route.name === 'allotment-documents') {
                this.process = PROCESS.ALLOTMENT;
                this.documentTitle = "Allotment Documents";
                this.isLoading = true;

                this.setupFilterByYearOptions()
                    .then(async() => {
                        this.fetchStartUpData();
                        await updateCurrentCompanyInStore().catch(() => {});
                    })
                    // eslint-disable-next-line no-console
                    .catch(e => console.log("Error while fetching filter by year options", e));
            } else if (this.$route.name === 'strike-off') {
                this.process = PROCESS.STRIKE_OFF;
                this.documentTitle = "Strike Off Documents";
                this.fetchStartUpData();
                await updateCurrentCompanyInStore().catch(() => {});
            } else if (this.$route.name === 'business-activities') {
                this.process = PROCESS.BUSINESS_ACTIVITIES;
                this.documentTitle = "Business Activities Documents";
                this.isLoading = true;

                this.setupFilterByYearOptions()
                    .then(async() => {
                        this.fetchStartUpData();
                        await updateCurrentCompanyInStore().catch(() => {});
                    })
                // eslint-disable-next-line no-console
                    .catch(e => console.log("Error while fetching filter by year options", e));
            } else if (this.$route.name === 'transfer-documents') {
                this.process = PROCESS.TRANSFER;
                this.documentTitle = "Transfer Documents";
                this.isLoading = true;

                this.setupFilterByYearOptions()
                    .then(async() => {
                        this.fetchStartUpData();
                        await updateCurrentCompanyInStore().catch(() => {});
                    })
                    // eslint-disable-next-line no-console
                    .catch(e => console.log("Error while fetching filter by year options", e));
            } else if (this.$route.name === 'share-cancellation-documents') {
                this.process = PROCESS.SHARE_CANCELLATION;
                this.documentTitle = "Share Reduction Documents";
                this.isLoading = true;

                this.setupFilterByYearOptions()
                    .then(async() => {
                        this.fetchStartUpData();
                        await updateCurrentCompanyInStore().catch(() => {});
                    })
                    // eslint-disable-next-line no-console
                    .catch(e => console.log("Error while fetching filter by year options", e));
            } else if (this.$route.name === 'share-buy-back-documents') {
                this.process = PROCESS.SHARE_BUY_BACK;
                this.documentTitle = "Share Buy Back Documents";
                this.isLoading = true;

                this.setupFilterByYearOptions()
                    .then(async() => {
                        this.fetchStartUpData();
                        await updateCurrentCompanyInStore().catch(() => {});
                    })
                    // eslint-disable-next-line no-console
                    .catch(e => console.log("Error while fetching filter by year options", e));
            } else if (this.$route.name === 'update-paid-up-capital-documents') {
                this.process = PROCESS.CAPITAL_PAYMENT;
                this.documentTitle = "Update Paid Up Capital Documents";
                this.isLoading = true;

                this.setupFilterByYearOptions()
                    .then(async() => {
                        this.fetchStartUpData();
                        await updateCurrentCompanyInStore().catch(() => {});
                    })
                    // eslint-disable-next-line no-console
                    .catch(e => console.log("Error while fetching filter by year options", e));
            } else if (this.$route.name === 'sale-of-property') {
                this.process = PROCESS.SALE_OF_PROPERTY;
                this.documentTitle = "Sale of Property";
                this.isLoading = true;

                this.setupFilterByYearOptions()
                    .then(async() => {
                        this.fetchStartUpData();
                        await updateCurrentCompanyInStore().catch(() => {});
                    })
                    // eslint-disable-next-line no-console
                    .catch(e => console.log("Error while fetching filter by year options of sale of property", e));
            } else {
                this.$router.push({name: 'error-404'}).catch(() => {});
            }
        },

        fetchStartUpData()
        {
            this.clearLocalData();
            this.getDocumentCount();
            this.getPendingYourSignaturesDocumentData();
        },

        async getDocumentCount() {
            const documents = await SigningList.getDocumentCount(this.process, this.filterData?.companyProcessId);
            this.$store.commit('document/SET_DOCUMENTS_COMPANY_PROCESS_ID', documents.company_process_id);

            this.documentCount = {
                reviewDocumentsCount: documents.review_documents_count,
                pendingDocumentsCount: documents.pending_documents_count,
                pendingOtherDocumentsCount: documents.pending_other_documents_count,
                pendingYourDocumentCount: documents.pending_your_documents_count,
                signedDocumentsCount: documents.signed_documents_count,
            };
        },

        clearLocalData() {
            // clear document data
            this.reviewDocumentsData = [];
            this.signedSignaturesDocumentData = [];
            this.pendingSignaturesDocumentData = [];
            this.pendingYourSignaturesDocumentData = [];
            this.pendingOtherSignaturesDocumentData = [];

            // clear document count
            this.documentCount = {
                reviewDocumentsCount: '--',
                pendingDocumentsCount: '--',
                pendingOtherDocumentsCount: '--',
                pendingYourDocumentCount: '--',
                signedDocumentsCount: '--',
            };
        },

        async getReviewDocuments() {
            this.activeComponent = 'ReviewDocuments';

            this.isLoading = this.reviewDocumentsData.length < 1;
            const documents = await SigningList.getDocuments(this.process, DOCUMENT.REVIEW_DOCUMENTS_STATUS, this.filterData?.companyProcessId);

            this.documentCount.reviewDocumentsCount = documents.data.length;

            this.reviewDocumentsData = documents.data.map(fileData => localize(fileData));
            this.isLoading = false;
        },

        download(documentIds) {
            this.isDownloadingZip = true;

            SigningList.download(this.process, documentIds.toString())
                .then(() => {
                    this.isDownloadingZip = false;
                    successToast(DOWNLOAD_REQUEST_SUCCESS);

                    // if currently working on sending mail live request then don't remove selected stuff
                    if(this.sendMailProcessingIntervalIds.length < 1) {
                        this.removeCurrentIdFromSelectedIds = documentIds;
                    }
                })
                .catch(error => {
                    this.isDownloadingZip =false;
                    errorToast(SOMETHING_WENT_WRONG);
                    console.log("Error while downloading zip in pre-incorporation.", error);
                });

        },

        sendEmail(documentIds) {
            this.isSendingMail = true;
            this.showEmailSentSuccessToast = true;

            this.$store.commit('document/SET_CURRENT_PROCESS', this.process);
            this.$store.commit('document/SET_CURRENT_SELECTED_DOCUMENTS', documentIds);
            this.$cache.set('is_coming_form', 'signing-document-process');

            SigningList.requestGmailAuthUrl()
                .then(response => {
                    console.log(response.data.url);
                    this.isSendingMail = false;
                    window.open(response.data.url, '_blank');
                })
                .catch(error => {
                    this.isSendingMail =false;
                    errorToast(SOMETHING_WENT_WRONG);
                    console.log("Error while sending mail in pre-incorporation.", error);
                });
        },

        async getPendingSignaturesDocumentData() {
            this.activeComponent = 'PendingSignaturesDocument';

            this.isLoading = this.pendingSignaturesDocumentData.length < 1;
            const documents = await SigningList.getDocuments(this.process, DOCUMENT.PENDING_SIGNATURE_STATUS, this.filterData?.companyProcessId);

            this.documentCount.pendingDocumentsCount = documents.data.length;

            this.pendingSignaturesDocumentData = documents.data.map(fileData => localize(fileData));
            this.isLoading = false;
        },

        async getPendingYourSignaturesDocumentData() {
            this.activeComponent = 'PendingYourSignaturesDocument';

            this.isLoading = this.pendingYourSignaturesDocumentData.length < 1;
            const documents = await SigningList.getDocuments(this.process, DOCUMENT.PENDING_YOUR_SIGNATURE_STATUS, this.filterData?.companyProcessId);

            this.documentCount.pendingYourDocumentCount = documents.data.length;

            this.pendingYourSignaturesDocumentData = documents.data.map(fileData => localize(fileData));

            const signProcessingDocsIds = [];
            documents.document_signature_status.forEach(signingProcessDocIds => {
                if(signingProcessDocIds) {
                    // eslint-disable-next-line radix
                    signProcessingDocsIds.push(parseInt(signingProcessDocIds));
                }
            });

            if(signProcessingDocsIds.length >= 1) {
                if(this.isSingInProcessingDocsLive) {
                // if current sign in processing docs exist then merge array without duplicating
                    this.signInProcessDocuments = [...new Set([...this.signInProcessDocuments, ...signProcessingDocsIds])];
                }
                else {
                // if current sign in processing docs doesn't exist then assign and request for live
                    this.signInProcessDocuments = signProcessingDocsIds;
                    this.setSignDocumentDataLive();
                }
            }

            this.setStatusForSignInProcessDocs();

            // current sending in process documents
            documents.sending_document_status.forEach(sendingInProcessDocId => {
                if(sendingInProcessDocId) {
                    // eslint-disable-next-line radix
                    if(! this.sendingInProcessDocIds.includes(parseInt(sendingInProcessDocId))) {
                        // eslint-disable-next-line radix
                        this.sendingInProcessDocIds.push(parseInt(sendingInProcessDocId));
                    }
                }
            });

            if(this.sendingInProcessDocIds.length >= 1) {
                this.$store.commit('document/SET_CURRENT_SELECTED_DOCUMENTS', this.sendingInProcessDocIds);
                this.setSendEmailDataLive();
            };

            this.isLoading = false;

            window.addEventListener('storage', async () => {
                if (window.localStorage.uploadedExternalDocument) {
                    const data = JSON.parse(window.localStorage.uploadedExternalDocument);
                    localStorage.removeItem('uploadedExternalDocument');
                    Document.requestExternalDocument(data.process, data.document).then(response => {
                        this.reviewDocumentsData.push(localize(response.document));
                        this.documentCount.reviewDocumentsCount += 1;
                    });
                }
            });
        },

        async getPendingOtherSignaturesDocumentData() {
            this.activeComponent = 'PendingOtherSignaturesDocument';

            this.isLoading = this.pendingOtherSignaturesDocumentData.length < 1;
            const documents = await SigningList.getDocuments(this.process, DOCUMENT.PENDING_OTHER_SIGNATURE_STATUS, this.filterData?.companyProcessId);

            this.documentCount.pendingOtherDocumentsCount = documents.data.length;

            this.pendingOtherSignaturesDocumentData = documents.data.map(fileData => localize(fileData));
            this.isLoading = false;
        },

        async getSignedSignaturesDocumentData() {
            this.activeComponent = 'SignedSignaturesDocument';

            this.isLoading = this.signedSignaturesDocumentData.length < 1;
            const documents = await SigningList.getDocuments(this.process, DOCUMENT.SIGNED_SIGNATURE_STATUS, this.filterData?.companyProcessId);

            this.documentCount.signedDocumentsCount = documents.data.length;

            this.signedSignaturesDocumentData = documents.data.map(fileData => localize(fileData));
            this.isLoading = false;
        },

        view(document)
        {
            // eslint-disable-next-line no-param-reassign
            document.requestingDocumentSignatureStatusForViewing = true;

            Document.getDocumentSignatureStatus(document.id).then(data => {
                // eslint-disable-next-line no-param-reassign
                if (data.data.is_signing)
                {
                    errorToast(ERROR_WHILE_TRYING_TO_VIEW_SIGNING_PROCESS_DOCUMENT);
                    // eslint-disable-next-line no-param-reassign
                    document.requestingDocumentSignatureStatusForViewing = false;
                    return;
                }

                this.activeDocumentId = document.id;
                this.shouldOpenPdfViewerModal = true;
                // eslint-disable-next-line no-param-reassign
                document.requestingDocumentSignatureStatusForViewing = false;
            });
        },

        sign(document)
        {
            this.pendingSignaturesDocumentData.forEach(singleDocument => {
                // eslint-disable-next-line no-param-reassign
                singleDocument.requestingDocumentSignatureStatus = false;
            });

            // eslint-disable-next-line no-param-reassign
            document.requestingDocumentSignatureStatus = true;

            Document.getDocumentSignatureStatus(document.id).then(data => {
                if (data.data.is_signing)
                {
                    errorToast(ERROR_WHILE_TRYING_TO_SIGN_SUBMITTED_TO_SIGN_DOCUMENT);
                    // eslint-disable-next-line no-param-reassign
                    document.requestingDocumentSignatureStatus = false;
                    return;
                }

                if (data.data.signed_at)
                {
                    errorToast(ERROR_WHILE_TRYING_TO_SIGN_ALREADY_SIGNED_DOCUMENT);
                    // eslint-disable-next-line no-param-reassign
                    document.requestingDocumentSignatureStatus = false;
                    return;
                }

                // eslint-disable-next-line no-param-reassign
                document.requestingDocumentSignatureStatus = false;

                this.isSignProcessing = true;

                this.signSingleDocumentIds.push(document.id);

                const routeData = this.$router.resolve({
                    name: 'sign.document',
                    params: {
                        document: document.id,
                        process: this.$route.name,
                    },
                });

                window.open(routeData.href, '_blank');
            }).catch(error => {
                errorToast(error);

                // eslint-disable-next-line no-param-reassign
                document.requestingDocumentSignatureStatus = false;
            });
        },

        signAll()
        {
            this.isSignProcessing = true;
            // this.signInProcessDocuments = [];
            this.pendingYourSignaturesDocumentData.forEach(pendingYourDocument => {
                if(! this.signInProcessDocuments.includes(pendingYourDocument.id))
                {
                    // this.signInProcessDocuments.push(pendingYourDocument.id);
                    this.signAllDocumentIds.push(pendingYourDocument.id);
                }
            });

            // company process id should same for all documents that's why get the first one
            // and save to store for request sign all document contents
            this.$store.commit('document/SET_DOCUMENTS_COMPANY_PROCESS_ID', this.pendingYourSignaturesDocumentData[0].companyProcessId);

            const routeData = this.$router.resolve({
                name: 'sign.document',
                params: {
                    document: 'all',
                    process: this.$route.name
                },
            });

            window.open(routeData.href, '_blank');
        },

        /* eslint-disable no-param-reassign */
        async setSignDocumentDataLive() {
            this.setStatusForSignInProcessDocs();
            this.$store.commit('document/CLEAR_SING_COMPLETED_DOC');

            const intervalId = setInterval(async() => {
                if(this.signInProcessDocuments.length > 0) {
                    this.isSingInProcessingDocsLive = true;

                    Document.getSignInProcessDocumentsStatus(this.signInProcessDocuments.toString())
                        .then(currentSignInProcessDocs => {
                            // success case
                            currentSignInProcessDocs.document_details.forEach(doc => {
                                if(doc.signed_at) {
                                    // remove doc from live data request list
                                    this.removeDocumentIdFromRequest(doc);

                                    // remove the record form table
                                    this.removeCurrentRecordFromPendingYourSignatureDocList(doc);

                                    // update count in table
                                    this.getDocumentCount();

                                    // fetch data if currently user already in active tab
                                    if(doc.completed_at) {
                                        if(this.activeComponent === "SignedSignaturesDocument") this.getSignedSignaturesDocumentData();
                                    }
                                    else if(! doc.completed_at) {
                                        if(this.activeComponent === "PendingOtherSignaturesDocument") this.getPendingOtherSignaturesDocumentData();
                                    }

                                    if(! this.$store.getters['document/getSignCompletedDocIds'].includes(doc.document_id))
                                        successToast(`${doc.name} has been signed successfully.`);

                                    this.$store.commit('document/SET_SIGN_COMPLETED_DOC', doc.document_id);
                                }
                            });

                            // error case
                            if(this.signInProcessDocuments.length > 0) {
                                const failDocumentIds = [];
                                this.signInProcessDocuments.forEach(signInProcessDocId => {
                                    // currentSignInProcessDocs.remaining.includes(signInProcessDocId.toString()
                                    if(! currentSignInProcessDocs.remaining.includes(signInProcessDocId.toString())) {
                                        this.pendingYourSignaturesDocumentData.forEach(pendingDocument => {
                                            pendingDocument.status = '';
                                            pendingDocument.isSigning = false;
                                        });
                                        this.removeDocumentIdFromRequest(signInProcessDocId);
                                        failDocumentIds.push(signInProcessDocId);
                                    }
                                });

                                // toast show only one time if in error case
                                if(failDocumentIds.length >= 1) {
                                    this.isSingInProcessingDocsLive = false;
                                    clearInterval(intervalId);
                                    console.log(SOMETHING_WENT_WRONG);
                                }
                            }
                        })
                        .catch(error => {
                            this.isSingInProcessingDocsLive = false;
                            clearInterval(intervalId);
                            console.log("Error while requesting signature", error);
                        });
                }
                else {
                    this.isSingInProcessingDocsLive = false;
                    clearInterval(intervalId);
                }
            }, 4000);

            this.signInProcessingIntervalIds.push(intervalId);
        },

        removeDocumentIdFromRequest(document) {
            // remove singing process doc list
            this.signInProcessDocuments = this.signInProcessDocuments.filter(oldId => oldId !== document.document_id);

            // remove sign single doc ids list
            this.signSingleDocumentIds = this.signSingleDocumentIds.filter(oldId => oldId !== document.document_id);

            // remove sign all doc ids list
            this.signAllDocumentIds = this.signAllDocumentIds.filter(oldId => oldId !== document.document_id);

            // set current sign in doc
            this.setCurrentRequestSignatureDoc(this.signInProcessDocuments[0]);
        },

        removeCurrentRecordFromPendingYourSignatureDocList(doc) {
            this.pendingYourSignaturesDocumentData = this.pendingYourSignaturesDocumentData.filter(pendingSignatureDoc => pendingSignatureDoc.id !== doc.document_id);
        },

        // set initial status for all sign in process documents
        setStatusForSignInProcessDocs() {
            this.pendingYourSignaturesDocumentData.forEach(pendingSignatureDoc => {
                if(this.signInProcessDocuments.includes(pendingSignatureDoc.id))
                {
                    pendingSignatureDoc.isSigning = true;
                    this.setCurrentRequestSignatureDoc(this.signInProcessDocuments[0]);
                }
                else
                {
                    pendingSignatureDoc.isSigning = false;
                    pendingSignatureDoc.status = '';
                }
            });
        },

        setCurrentRequestSignatureDoc(currentSignatureRequestDocId) {
            this.pendingYourSignaturesDocumentData.forEach(pendingSignatureDoc => {
                if(pendingSignatureDoc.id === currentSignatureRequestDocId)
                    pendingSignatureDoc.status = "Signing in progress";
            });
        },

        /* eslint-disable no-param-reassign */
        async setSendEmailDataLive() {
            this.setStatusForSendEmailDocs();

            const sendEmailIntervalId = setInterval(async() => {
                if(this.$store.getters['document/getCurrentSelectedDocuments'].length < 1) clearInterval(sendEmailIntervalId);

                const currentSendingEmailProcessDocs = await Document.getDocumentEmailStatus(this.$store.getters['document/getCurrentSelectedDocuments'].toString());

                // success case
                currentSendingEmailProcessDocs.document_details.forEach(doc => {
                    if(doc.sent_at) {
                        this.removeDocFromSendingMailLiveList(doc.document_id);

                        // update status in table
                        this.reviewDocumentsData.forEach(reviewDoc => {
                            if(doc.document_id === reviewDoc.id) {
                                reviewDoc.sentOn = formatDate(doc.sent_at);
                                reviewDoc.status = DOCUMENT.STATUES.SENT;
                            }
                        });

                        this.removeCurrentIdFromSelectedIds.push(doc.document_id);
                        // successToast(`${doc.name} has been sent successfully.`);
                    }
                });

                // error case
                if(this.$store.getters['document/getCurrentSelectedDocuments'].length > 0) {
                    const failDocumentIds = [];
                    this.$store.getters['document/getCurrentSelectedDocuments'].forEach(sendInMailProcessDocId => {
                        if(! currentSendingEmailProcessDocs.remaining.includes(sendInMailProcessDocId.toString())) {
                            this.reviewDocumentsData.forEach(reviewDocument => {
                                if(this.$store.getters['document/getCurrentSelectedDocuments'].includes(reviewDocument.id)) {
                                    reviewDocument.status = DOCUMENT.STATUES.DRAFT;
                                    reviewDocument.sentOn = '';
                                }
                            });
                            this.removeDocFromSendingMailLiveList(sendInMailProcessDocId);
                            failDocumentIds.push(sendInMailProcessDocId);
                        }
                    });

                    // toast show only one time if in error case
                    if(failDocumentIds.length >= 1) {
                        clearInterval(sendEmailIntervalId);
                        errorToast(SOMETHING_WENT_WRONG);
                    }
                }

                if(this.$store.getters['document/getCurrentSelectedDocuments'].length < 1) clearInterval(sendEmailIntervalId);
            }, 8000);

            this.sendMailProcessingIntervalIds.push(sendEmailIntervalId);
        },

        setStatusForSendEmailDocs() {
            this.reviewDocumentsData.forEach(reviewDoc => {
                if(this.$store.getters['document/getCurrentSelectedDocuments'].includes(reviewDoc.id))
                {
                    reviewDoc.status = "Sending";
                }
            });
        },

        removeDocFromSendingMailLiveList(id) {
            const filterIds = this.$store.getters['document/getCurrentSelectedDocuments'].filter(currentSelectedDocId => currentSelectedDocId !== id);
            this.$store.commit('document/SET_CURRENT_SELECTED_DOCUMENTS', filterIds);
        },

        async setupFilterByYearOptions() {
            await this.$store.dispatch('filterDocuments/SET_FILTER_OPTIONS', this.process);
        },

        filterBy(filter) {
            this.$store.commit('filterDocuments/SET_FILTER_BY', filter);

            this.clearLocalData();
            this.getDocumentCount();

            if(this.activeComponent === 'ReviewDocuments') {
                this.getReviewDocuments();
            }
            if(this.activeComponent === 'PendingSignaturesDocument') {
                this.getPendingSignaturesDocumentData();
            }
            if(this.activeComponent === 'PendingYourSignaturesDocument') {
                this.getPendingYourSignaturesDocumentData();
            }
            if(this.activeComponent === 'SignedSignaturesDocument') {
                this.getSignedSignaturesDocumentData();
            }
        },

        uploadExternalDocument(document) {
            successToast(`${document.fileName} is uploading. Please wait for a moment.`);
            this.isUploadingExternalDocument = true;
            Document.uploadExternalDocument(document, this.process, this.$store.getters['document/getDocumentsCompanyProcessId']).then(response => {
                // redirect to review document page
                const route = this.$router.resolve({
                    name: 'prepare-external-documents',
                    params: {
                        process: this.process,
                        document: response.filename
                    }
                });
                this.isUploadingExternalDocument = false;
                window.open(route.href, '_blank');
            }).catch(err => {
                console.error(err);
                errorToast(SOMETHING_WENT_WRONG);
            });
        },

        remove(data) {
            this.$refs.modal.$refs.confirmationModal.show();
            this.dataToDelete= data;
            this.isDeleting = false;
        },

        cancelDelete() {
            this.dataToDelete = null;
            this.$refs.modal.$refs.confirmationModal.hide();
        },

        confirmDelete() {
            this.isDeleting = true;
            Document.delete(this.dataToDelete).then(() => {
                this.reviewDocumentsData = this.reviewDocumentsData.filter(reviewDocument => reviewDocument.id !== this.dataToDelete.id);
                this.documentCount.reviewDocumentsCount -= 1;
                successToast(`Document: ${this.dataToDelete.fileName} has been deleted.`);
                this.isDeleting = false;
                this.$refs.modal.$refs.confirmationModal.hide();
            }).catch(err => {
                console.error(err);
                errorToast(SOMETHING_WENT_WRONG);
            });
        },

        physicallySigned(data) {
            Document.physicallySigned(data.item)
                .then(() => {
                    data.item.status = DOCUMENT.STATUES.PHYSICALLY_SIGNED;

                    this.removeCurrentRecordFromPendingYourSignatureDocList(data.item);
                    this.getDocumentCount();

                    successToast(`${data.item.fileName} has been successfully marked as physically signed.`);
                })
                .catch(error => {
                    this.isSideBarActionLoading = false;
                    if(error.response?.data?.message) {
                        errorToast(error.response?.data?.message);
                    }
                    else errorToast(SOMETHING_WENT_WRONG);
                    // eslint-disable-next-line no-console
                    console.log("Error while trying to mark as dropbox sign ", error);
                });
        },

        dropboxSigned(data) {
            Document.dropboxSigned(data.item)
                .then(() => {
                    data.item.status = DOCUMENT.STATUES.DROPBOX_SIGNED;

                    this.removeCurrentRecordFromPendingYourSignatureDocList(data.item);
                    this.getDocumentCount();

                    successToast(`${data.item.fileName} has been successfully marked as dropbox signed.`);
                })
                .catch(error => {
                    this.isSideBarActionLoading = false;
                    if(error.response?.data?.message) {
                        errorToast(error.response?.data?.message);
                    }
                    else errorToast(SOMETHING_WENT_WRONG);
                    // eslint-disable-next-line no-console
                    console.log("Error while trying to mark as dropbox signed ", error);
                });
        },

        markAsSigned(data) {
            Document.markAsSigned(data.item)
                .then(() => {
                    data.item.status = DOCUMENT.STATUES.MARK_AS_SIGNED;

                    this.removeCurrentRecordFromPendingYourSignatureDocList(data.item);
                    this.getDocumentCount();

                    successToast(`${data.item.fileName} has been successfully marked as mark as signed.`);
                })
                .catch(error => {
                    this.isSideBarActionLoading = false;
                    if(error.response?.data?.message) {
                        errorToast(error.response?.data?.message);
                    }
                    else errorToast(SOMETHING_WENT_WRONG);
                    // eslint-disable-next-line no-console
                    console.log("Error while trying to marked as signed ", error);
                });
        },

        revert(data) {
            this.isRevertSidebarActive = true;
            this.dataToRevert = data;
        },

        revertNow() {
            Document
                .revert(this.dataToRevert.id)
                .then(response => {
                    this.reviewDocumentsData.find(document => document.id === this.dataToRevert.id).status = DOCUMENT.STATUES.DRAFT;
                    window.open(response.data.url, '_blank').focus();
                    this.isRevertSidebarActive = false;
                    window.location.reload();
                });
        }
    }
};
</script>

<style>
    .signings-tab .tab-title {
        border-bottom: 1px solid #e3e3e3;
        padding: 13px 15px;
        font-weight: 500;
    }

    .signings-tab .nav-tabs .nav-link {
        margin-bottom: -1px;
        border: 1px solid transparent;
        border-top-left-radius: 0.25rem;
        border-top-right-radius: 0.25rem;
        padding: 0.51rem 0.7rem
    }

    .signings-tab .nav-tabs .nav-link.active {
        color: #495057;
        background-color: #fff;
        border-color: #dee2e6 #dee2e6 #fff;
    }

    .signings-tab .card-header-tabs {
        margin-right: -0.625rem;
        margin-left: -0.625rem;
        margin-bottom: -0.75rem;
        border-bottom: 0;
    }

    .signings-tab .nav-tabs .nav-link.active:after {
        display: none !important;
    }

    .signings-tab .status-circle {
        width: 13px;
        height: 13px;
        display: inline-block;
        border-radius: 50%;
        position: relative;
        top: 2px;
        right: 3px;
    }

    /* .signings-tab .status-circle.pending {
        background: #ffc107!important ;
    }

    .signings-tab .status-circle.completed {
        background: #28c76f;
    } */

    .signings-tab .card-header {
        padding: 0.75rem 1.25rem;
        margin-bottom: 0;
        background-color: rgba(0,0,0,.03);
        border-bottom: 1px solid rgba(0,0,0,.125);
    }

    .signings-tab .status-count {
        font-size: 12.4px;
        color: white;
        display: inline-block;
        width: 24px;
        height: 24px;
        /* background: #4267B2; */
        border-radius: 50%;
        padding-top: 3.2px;
        text-align: center;
    }

    .signings-tab .status-count.pending {
        background: #ffc107!important ;
     }

    .signings-tab .status-count.completed {
        background: #28c76f;
    }
</style>
